import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import type React from 'react';
import {
	AbsoluteFill,
	Easing,
	Freeze,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const TimelineVideoRollingEditContent = () => {
	const {fps} = useVideoConfig();
	// Keep cursor keyframes and recording on the captured 60 fps clock.
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(352 / 60) * fps}
			style={{
				width: 2560,
				height: 1312,
				rotate: '0.620975 0.651947 -0.43515 27.514238deg',
				scale: 1.372,
			}}
			trimBefore={(84 / 60) * fps}
		>
			<Video
				src="https://remotion.media/studio-close-ups/timeline-video-rolling-edit-dcc776192258.mp4"
				durationInFrames={(436 / 60) * fps}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[-76, -37, 257],
					['auto', 'custom', 'auto'],
					{
						easing: [Easing.step1, Easing.step1],
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={interpolate(
					frame,
					[-37, -7, 254],
					[
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E") 2 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, e-resize',
					],
					{
						easing: [Easing.step1, Easing.step1],
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[-84, 29, 218, 302, 308],
						[
							4.356809509247317, 3.921128558322586, 4.356809509247317,
							3.921128558322586, 4.356809509247317,
						],
						{
							easing: [Easing.step1, Easing.step1, Easing.step1, Easing.step1],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-76, -75, -74, -73, -72, -71, -70, -69, -68, -67, -66, -65, -64,
							-63, -62, -61, -60, -59, -58, -57, -56, -55, -54, -53, -52, -51,
							-50, -49, -48, -47, -46, -45, -44, -43, -42, -41, -40, -39, -38,
							-37, -36, -35, -34, -33, -32, -31, -30, -29, -28, -27, -26, -25,
							-22, -21, -10, -9, -8, -7, -6, -5, -4, 63, 64, 66, 67, 68, 69, 70,
							71, 72, 73, 74, 75, 76, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
							88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
							103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115,
							116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
							129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 149, 150, 151, 152, 153, 154, 155,
							156, 157, 158, 159, 160, 161, 163, 164, 165, 166, 253, 254, 255,
							256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268,
							269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281,
							282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294,
							295, 296, 297, 298, 299, 300, 301,
						],
						[
							'1794.9034050870218px 1703.172142372791px',
							'1773.6299211551502px 1680.622249405007px',
							'1755.249631038013px 1662.24195928787px',
							'1736.8863597080212px 1636.781853718206px',
							'1723.9520814774435px 1613.857547433221px',
							'1717.4679235750089px 1590.9332411482362px',
							'1703.274255095664px 1566.1198494901012px',
							'1685.540678890056px 1541.306457831966px',
							'1667.8071026844477px 1516.4930661738308px',
							'1651.3329167276063px 1497.1086676151094px',
							'1639.658028745795px 1479.6133544295383px',
							'1621.9244525401868px 1454.799962771403px',
							'1604.1908763345787px 1429.986571113268px',
							'1579.1392216564066px 1392.3920703088643px',
							'1554.0875669782345px 1354.7975695044606px',
							'1522.313491377591px 1314.0375742909946px',
							'1458.8163965377405px 1229.9988033665288px',
							'1444.3844650383587px 1201.1349403677652px',
							'1421.2218957333369px 1169.6161465743041px',
							'1389.4478201326933px 1124.6865485101912px',
							'1364.3961654545212px 1087.0920477057878px',
							'1339.3445107763491px 1049.497546901384px',
							'1309.9360465889297px 1007.1888420576777px',
							'1309.9360465889297px 1007.1888420576777px',
							'1296.5762986797145px 985.0984563428221px',
							'1291.3515310260466px 971.7557272207522px',
							'1286.126763372379px 958.4129980986824px',
							'1280.9019957187113px 945.0702689766124px',
							'1275.0475329406602px 927.5749557910411px',
							'1263.985321296087px 905.4845700761856px',
							'1255.2206459161557px 887.9892568906143px',
							'1249.3832019252502px 879.2416002978288px',
							'1247.0856656606081px 874.6465277685445px',
							'1233.7259177513927px 852.556142053689px',
							'1225.590937495845px 839.213412931619px',
							'1213.9160495140338px 821.7180997460478px',
							'1205.781069258486px 808.3753706239778px',
							'1195.3485527382961px 795.032641501908px',
							'1177.8362207655794px 768.789671723551px',
							'1167.1994787996437px 758.1529297576152px',
							'1156.7669622794538px 744.8102006355454px',
							'1148.631982023906px 731.4674715134754px',
							'1137.1443007006953px 719.9797901902647px',
							'1133.1789232957944px 713.7168765207217px',
							'1129.843241015277px 710.3811942402042px',
							'1125.8778636103762px 704.1182805706612px',
							'1121.9124862054753px 697.8553669011181px',
							'1115.0198774115488px 688.6652218425496px',
							'1111.054500006648px 682.4023081730065px',
							'1108.7569637420058px 676.1393945034636px',
							'1107.089122601747px 672.803712222946px',
							'1105.4212814614882px 671.1358710826873px',
							'1105.4212814614882px 671.1358710826873px',
							'1105.4212814614882px 670.0126311310845px',
							'1105.4212814614882px 670.0126311310845px',
							'1105.4212814614882px 667.8172075893153px',
							'1100.826208932204px 667.8172075893153px',
							'1099.4476871734187px 666.4386858305301px',
							'1099.4476871734187px 665.0771828588903px',
							'1099.4476871734187px 665.0771828588903px',
							'1098.2393532860883px 665.0771828588903px',
							'1098.2393532860883px 665.0771828588903px',
							'1098.7499169004534px 665.0771828588903px',
							'1098.7499169004534px 665.0771828588903px',
							'1099.8050817034741px 665.0771828588903px',
							'1099.8050817034741px 665.0771828588903px',
							'1100.928321655077px 665.0771828588903px',
							'1100.928321655077px 665.0771828588903px',
							'1103.4811397269016px 665.0771828588903px',
							'1104.96177420856px 665.0771828588903px',
							'1104.96177420856px 665.0771828588903px',
							'1114.9858398372578px 666.6939676377125px',
							'1114.9858398372578px 666.6939676377125px',
							'1119.887250535161px 666.710986424858px',
							'1119.887250535161px 666.710986424858px',
							'1127.6988738349444px 666.710986424858px',
							'1127.6988738349444px 666.710986424858px',
							'1145.653694273444px 668.9915039023547px',
							'1149.687146826927px 669.961574769648px',
							'1149.687146826927px 669.961574769648px',
							'1161.4811663187566px 672.0378668013986px',
							'1163.3191953304702px 672.8547685843826px',
							'1163.3191953304702px 672.8547685843826px',
							'1177.546901384106px 674.5055909374959px',
							'1177.546901384106px 674.5055909374959px',
							'1190.583292337557px 676.564864182101px',
							'1190.583292337557px 676.564864182101px',
							'1201.8327106407307px 678.9985507439071px',
							'1201.8327106407307px 678.9985507439071px',
							'1217.5240323888793px 682.3512518115701px',
							'1222.1191049181634px 683.4574729760274px',
							'1222.1191049181634px 683.4574729760274px',
							'1240.6525641196101px 685.2444456263046px',
							'1240.6525641196101px 685.2444456263046px',
							'1259.1690045339112px 689.805480581298px',
							'1259.1690045339112px 689.805480581298px',
							'1270.1631410299026px 692.0859980587945px',
							'1273.2775790775286px 692.0859980587945px',
							'1273.2775790775286px 692.0859980587945px',
							'1288.1860366169842px 694.1452713033998px',
							'1291.4366249617742px 694.2814216005637px',
							'1291.4366249617742px 694.2814216005637px',
							'1319.3814734546809px 696.6129954394969px',
							'1319.3814734546809px 696.6129954394969px',
							'1336.740636343088px 697.2767281381713px',
							'1340.331600430788px 698.2127614311736px',
							'1340.331600430788px 698.2127614311736px',
							'1360.5669383467844px 698.842456555557px',
							'1360.5669383467844px 698.842456555557px',
							'1372.0035633085586px 698.842456555557px',
							'1375.3562643762216px 698.842456555557px',
							'1387.8820917153075px 700.9868237358896px',
							'1392.6643709031923px 701.0719176716171px',
							'1392.6643709031923px 701.0719176716171px',
							'1417.460743774182px 702.229195197511px',
							'1417.460743774182px 702.229195197511px',
							'1428.2676736115727px 703.3694539362593px',
							'1432.8457273537115px 703.3694539362593px',
							'1452.2301259124329px 703.3694539362593px',
							'1456.3146348273524px 703.3694539362593px',
							'1467.70020342769px 703.3694539362593px',
							'1472.3463323184108px 703.3694539362593px',
							'1477.0264987834225px 703.3694539362593px',
							'1495.5769767720146px 703.3694539362593px',
							'1498.6914148196406px 703.3694539362593px',
							'1507.9155974525002px 703.3694539362593px',
							'1511.1661857972902px 703.3694539362593px',
							'1511.1661857972902px 703.3694539362593px',
							'1521.2242890002792px 703.3694539362593px',
							'1521.2242890002792px 703.3694539362593px',
							'1529.8528140830463px 703.3694539362593px',
							'1529.8528140830463px 703.3694539362593px',
							'1531.520655223305px 703.3694539362593px',
							'1532.9842709178179px 703.3694539362593px',
							'1532.9842709178179px 703.3694539362593px',
							'1534.2436611665846px 703.3694539362593px',
							'1536.9836858970098px 703.3694539362593px',
							'1542.2765286992594px 703.3694539362593px',
							'1542.2765286992594px 703.3694539362593px',
							'1552.5899137094307px 703.3694539362593px',
							'1552.5899137094307px 703.3694539362593px',
							'1561.0993072821793px 703.3694539362593px',
							'1561.0993072821793px 703.3694539362593px',
							'1562.6650356995651px 703.3694539362593px',
							'1562.6650356995651px 703.3694539362593px',
							'1563.9074071611865px 703.3694539362593px',
							'1569.1491936019997px 703.3694539362593px',
							'1572.076424991025px 703.3694539362593px',
							'1572.076424991025px 703.3694539362593px',
							'1586.27009347037px 703.3694539362593px',
							'1586.27009347037px 703.3694539362593px',
							'1596.7536663519963px 703.3694539362593px',
							'1596.7536663519963px 703.3694539362593px',
							'1601.8593024956456px 703.3694539362593px',
							'1603.5101248487588px 703.3694539362593px',
							'1603.5101248487588px 703.3694539362593px',
							'1613.4150589674382px 703.3694539362593px',
							'1613.4150589674382px 703.3694539362593px',
							'1621.1926446929306px 703.3694539362593px',
							'1621.1926446929306px 703.3694539362593px',
							'1622.7243355360251px 703.3694539362593px',
							'1622.7243355360251px 703.3694539362593px',
							'1622.7243355360251px 707.5901131483427px',
							'1622.7243355360251px 742.6147770937762px',
							'1622.7243355360251px 780.7198415125447px',
							'1622.7243355360251px 926.7410352209118px',
							'1622.7243355360251px 975.4147664570341px',
							'1622.7243355360251px 1042.3666750874206px',
							'1622.7243355360251px 1118.5768039249576px',
							'1622.7243355360251px 1185.5287125553443px',
							'1627.5236335110556px 1243.2224009785803px',
							'1635.8628392123492px 1284.9524670593396px',
							'1643.5723497892595px 1319.9771310047731px',
							'1651.2818603661697px 1355.0017949502067px',
							'1657.7319806943133px 1377.8920636609007px',
							'1664.1821010224567px 1400.7823323715945px',
							'1670.0025262262168px 1418.243607982875px',
							'1675.1932563055934px 1431.5522995306537px',
							'1679.7542912605868px 1440.7084070149313px',
							'1682.0348087380835px 1454.01709856271px',
							'1685.9661485686934px 1460.2459746579623px',
							'1687.6169709218066px 1463.5476193641887px',
							'1687.6169709218066px 1466.849264070415px',
							'1695.4966693701717px 1472.4314262541384px',
							'1705.8951483160706px 1485.7401178019172px',
							'1721.092925237px 1500.9378947228463px',
							'1728.5811915810186px 1514.2465862706251px',
							'1737.3118293866587px 1531.7078618819055px',
							'1744.8000957306776px 1545.0165534296843px',
							'1749.361130685671px 1554.172660913962px',
							'1754.5518607650476px 1567.481352461741px',
							'1758.4832005956575px 1573.710228556993px',
							'1763.0442355506507px 1582.8663360412704px',
							'1767.605270505644px 1592.022443525548px',
							'1772.7960005850207px 1605.331135073327px',
							'1776.7273404156306px 1611.560011168579px',
							'1780.6586802462405px 1617.788887263831px',
							'1784.5900200768504px 1624.0177633590831px',
							'1788.5213599074602px 1630.246639454335px',
							'1790.801877384957px 1636.475515549587px',
							'1792.4526997380701px 1639.7771602558137px',
							'1796.38403956868px 1646.0060363510656px',
							'1800.9450745236734px 1655.1621438353432px',
							'1809.454468096422px 1665.9690736727339px',
							'1813.385807927032px 1672.197949767986px',
							'1817.3171477576418px 1678.426825863238px',
							'1818.967970110755px 1681.7284705694644px',
							'1818.967970110755px 1683.0899735411042px',
							'1818.967970110755px 1683.0899735411042px',
							'1820.3294730823948px 1683.0899735411042px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const TimelineVideoRollingEditFrame = ({
	children,
}: {
	readonly children: React.ReactNode;
}) => {
	const {width, height} = useVideoConfig();

	return (
		<CloseUpFrame>
			<div
				style={{
					position: 'absolute',
					width: 2560,
					height: 1312,
					left: '50%',
					top: '50%',
					translate: '-50% -50%',
					scale: Math.min(width / 2560, height / 1312),
					overflow: 'hidden',
				}}
			>
				{children}
			</div>
		</CloseUpFrame>
	);
};

const TimelineVideoRollingEditCompositionContent = () => (
	<Interactive.Div
		name="Rolling edit - hold final stutter framing"
		style={{position: 'absolute', inset: 0, scale: 1.8}}
	>
		<TimelineVideoRollingEditFrame>
			<TimelineVideoRollingEditContent />
		</TimelineVideoRollingEditFrame>
	</Interactive.Div>
);

const TimelineVideoRollingPreludeContent = () => {
	const frame = useCurrentFrame();
	const {fps} = useVideoConfig();

	return (
		<Interactive.Div
			name="Two bass stutters - frozen UI zoom"
			style={{
				position: 'absolute',
				inset: 0,
				scale: interpolate(
					frame,
					[0, (3 / 30) * fps, (6 / 30) * fps],
					[1.5, 1.65, 1.8],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						output: 'perceptual-scale',
					},
				),
			}}
		>
			<TimelineVideoRollingEditFrame>
				{/* Match the next shot's trim, then release the freeze at its cut. */}
				<Freeze frame={(32 / 30) * fps}>
					<TimelineVideoRollingEditContent />
				</Freeze>
			</TimelineVideoRollingEditFrame>
		</Interactive.Div>
	);
};

export const TimelineVideoRollingPrelude = Interactive.create({
	Component: TimelineVideoRollingPreludeContent,
	layout: 'absolute-fill',
	schema: {},
});

export const TimelineVideoRollingEditComposition = Interactive.create({
	Component: TimelineVideoRollingEditCompositionContent,
	layout: 'absolute-fill',
	schema: {},
});
